import { render, staticRenderFns } from "./ReferencesForm.vue?vue&type=template&id=481a5732&scoped=true"
import script from "./ReferencesForm.vue?vue&type=script&lang=js"
export * from "./ReferencesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a5732",
  null
  
)

export default component.exports